




























import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class SpecialCoinOffer extends Vue {
  @Prop({ default: '25' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
}
